export default __webpack_public_path__ + "static/media/Mosaic1-min.29fc2516.jpg";